module.exports = __webpack_public_path__ + "img/logo.964af733.png";